// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container, .login-section {
  background: white;
  padding: 4rem 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  margin: 2rem auto;
  max-width: 400px;
  width: 100%;
}

.create-account-section {
  background: white;
  padding: 4rem 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
  margin: 2rem auto;
}

.login-logo {
  width: 60px;
  height: auto;
  margin-bottom: 1.5rem;
}

h2 {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 2rem;
  color: #2B2B2B;
  margin-bottom: 2rem;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}

.form-group {
  position: relative;
  width: 100%;
}

.form-group input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  font-family: 'Josefin Sans', sans-serif;
  font-size: 1rem;
}

.form-group input:focus {
  outline: none;
  border-color: #D4AF37;
}

.forgot-password {
  display: block;
  text-align: right;
  color: #666;
  text-decoration: none;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  transition: color 0.3s ease;
}

.forgot-password:hover {
  color: #D4AF37;
}

.form-actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
  width: 100%;
}

.btn {
  width: 100%;
  padding: 0.75rem;
  border: none;
  border-radius: 4px;
  font-family: 'Josefin Sans', sans-serif;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary {
  background-color: #526015;
  color: white;
}

.btn-primary:hover {
  background-color: #455112;
  transform: translateY(-1px);
}

.btn-secondary {
  background-color: #f0f0f0;
  color: #271F12;
}

.btn-secondary:hover {
  background-color: #e0e0e0;
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .login-container, .login-section, .create-account-section {
    padding: 2rem 1.5rem;
    margin: 1rem;
    border-radius: 6px;
  }

  h2 {
    font-size: 1.75rem;
    margin-bottom: 1.5rem;
  }

  .form-group input {
    padding: 0.875rem;
    font-size: 1rem;
  }

  .btn {
    padding: 0.875rem;
  }
}

@media (max-width: 480px) {
  .login-container, .login-section, .create-account-section {
    padding: 1.5rem 1rem;
    margin: 0.5rem;
  }

  h2 {
    font-size: 1.5rem;
    margin-bottom: 1.25rem;
  }

  .login-logo {
    width: 50px;
    margin-bottom: 1rem;
  }

  .form-group input {
    padding: 0.75rem;
    font-size: 0.95rem;
  }

  .forgot-password {
    font-size: 0.85rem;
  }

  .btn {
    padding: 0.75rem;
    font-size: 0.95rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE;IACE,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF","sourcesContent":[".login-container, .login-section {\n  background: white;\n  padding: 4rem 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  margin: 2rem auto;\n  max-width: 400px;\n  width: 100%;\n}\n\n.create-account-section {\n  background: white;\n  padding: 4rem 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  max-width: 400px;\n  width: 100%;\n  margin: 2rem auto;\n}\n\n.login-logo {\n  width: 60px;\n  height: auto;\n  margin-bottom: 1.5rem;\n}\n\nh2 {\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 2rem;\n  color: #2B2B2B;\n  margin-bottom: 2rem;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 100%;\n}\n\n.form-group {\n  position: relative;\n  width: 100%;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #E5E5E5;\n  border-radius: 4px;\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 1rem;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #D4AF37;\n}\n\n.forgot-password {\n  display: block;\n  text-align: right;\n  color: #666;\n  text-decoration: none;\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n  transition: color 0.3s ease;\n}\n\n.forgot-password:hover {\n  color: #D4AF37;\n}\n\n.form-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  width: 100%;\n}\n\n.btn {\n  width: 100%;\n  padding: 0.75rem;\n  border: none;\n  border-radius: 4px;\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-primary {\n  background-color: #526015;\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: #455112;\n  transform: translateY(-1px);\n}\n\n.btn-secondary {\n  background-color: #f0f0f0;\n  color: #271F12;\n}\n\n.btn-secondary:hover {\n  background-color: #e0e0e0;\n  transform: translateY(-1px);\n}\n\n@media (max-width: 768px) {\n  .login-container, .login-section, .create-account-section {\n    padding: 2rem 1.5rem;\n    margin: 1rem;\n    border-radius: 6px;\n  }\n\n  h2 {\n    font-size: 1.75rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .form-group input {\n    padding: 0.875rem;\n    font-size: 1rem;\n  }\n\n  .btn {\n    padding: 0.875rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .login-container, .login-section, .create-account-section {\n    padding: 1.5rem 1rem;\n    margin: 0.5rem;\n  }\n\n  h2 {\n    font-size: 1.5rem;\n    margin-bottom: 1.25rem;\n  }\n\n  .login-logo {\n    width: 50px;\n    margin-bottom: 1rem;\n  }\n\n  .form-group input {\n    padding: 0.75rem;\n    font-size: 0.95rem;\n  }\n\n  .forgot-password {\n    font-size: 0.85rem;\n  }\n\n  .btn {\n    padding: 0.75rem;\n    font-size: 0.95rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
